import React from 'react'

import {useAppDispatch} from '../../hooks/redux'
import {openSimpleContentModal} from '../../redux/features/modal'

import {formatDateTime, formatPrice} from '../../libs/formatter'

import ActionBar from '../../../../commons/src/components/action-bar'
import LinkButton from '../../../../commons/src/components/link-button'
import Paragraph from '../../../../commons/src/components/paragraph'
import Stack from '../../../../commons/src/components/stack'
import TruncatedLabel from '../../../../commons/src/components/truncated-label'

import {AdditionalCost} from '../../order-types'

type Props = {
  additionalCost: AdditionalCost
  hidePostFix?: boolean
}

const AdditionalCostPartial = ({additionalCost, hidePostFix = false}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Stack space="60" key={additionalCost.created}>
      <ActionBar>
        <Paragraph size="s" className="u-no-margin">
          {formatDateTime(additionalCost.created)}
        </Paragraph>
        <Paragraph size="s" strong className="u-no-margin">
          {formatPrice(additionalCost.amounts.netPrice, additionalCost.amounts.currency, 2)}
        </Paragraph>
        <Paragraph size="s" minor className="u-no-margin-bottom">
          {additionalCost.status.paid ? 'Paid' : 'Awaiting Payment'}
        </Paragraph>
      </ActionBar>
      <TruncatedLabel
        size="s"
        hidePostfix
        maxWidth
        postfix={
          !hidePostFix ? (
            <LinkButton
              onClick={() => {
                dispatch(
                  openSimpleContentModal({
                    title: 'Description',
                    content: <Paragraph>{additionalCost.description}</Paragraph>,
                  })
                )
              }}
            >
              show
            </LinkButton>
          ) : undefined
        }
      >
        {`"${additionalCost.description}"`}
      </TruncatedLabel>
    </Stack>
  )
}

export default AdditionalCostPartial
